import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';

export const filtersApi = createApi({
  reducerPath: 'filterOptions',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getCrops: build.mutation({
      query: (payload) => ({
        url: 'crop-location/crops',
        method: 'POST',
        body: payload,
      }),
    }),
    getStates: build.mutation({
      query: (payload) => ({
        url: 'crop-location/states',
        method: 'POST',
        body: payload,
      }),
    }),
    getDistricts: build.mutation({
      query: (payload) => ({
        url: 'crop-location/districts',
        method: 'POST',
        body: payload,
      }),
    }),
    getSubDistricts: build.mutation({
      query: (payload) => ({
        url: 'crop-location/sub-districts',
        method: 'POST',
        body: payload,
      }),
    }),
    getVillages: build.mutation({
      query: (payload) => ({
        url: 'crop-location/villages',
        method: 'POST',
        body: payload,
      }),
    }),
    getInfestations: build.mutation({
      query: (payload) => ({
        url: 'crop-location/infestations',
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetCropsMutation,
  useGetStatesMutation,
  useGetDistrictsMutation,
  useGetInfestationsMutation,
  useGetSubDistrictsMutation,
  useGetVillagesMutation,
} = filtersApi;
